<template>
    <section class="container" ref="homeCont">
      <div class="route">
        {{$locales.ajustes.ajustes}} > {{$locales.ajustes.alertas.alertas}} > {{$locales.ajustes.alertas.facturas}}
      </div>
      <div class="sidebar">
        <span class="principal">
          <span class="icon">J  </span>{{$locales.ajustes.ajustes}}
        </span>
        <ul>
          <li @click="toggle">
            <span class="sidebar-item"><span class="arrow">&#9660;</span>{{$locales.ajustes.alertas.alertas}}</span>
                <span @click="refresh"><router-link to="/onesaitConfirmingProviders/ajustes/alertas/facturas"  class="link-active" v-if="active">
                  {{$locales.ajustes.alertas.facturas}}
                </router-link></span>
          </li>
          <li  @click="toggle2">
                <span class="sidebar-item">
                  <span class="arrow">&#9660; </span>{{$locales.ajustes.seguridadclaves.seguridadclaves}}
                </span>
                <router-link to="/onesaitConfirmingProviders/ajustes/modificar-contrasena" class="link" v-if="active2">
                {{$locales.ajustes.seguridadclaves.modificarpassword}}
                </router-link>
                <router-link to="/onesaitConfirmingProviders/ajustes/modificar-claveFirma"  class="link" v-if="active2">
                {{$locales.ajustes.seguridadclaves.modificarclavefirma}}
                </router-link>
          </li>
          <li  @click="toggle3">
                <span class="sidebar-item">
                  <span class="arrow">&#9660; </span>{{$locales.ajustes.datospersonales.datospersonales}}
                </span>
                <router-link to="/onesaitConfirmingProviders/ajustes/datos-personales/modificar-datos" class="link" v-if="active3">
                {{$locales.ajustes.datospersonales.modificardatos}}
                </router-link>
          </li>
        </ul>
      </div>
      <div class="window">
        <div class="mensajeConfirmacion" v-if="confirmacion=='OK'">
          <p>check_circle</p>
          <h3>Operación realizada con éxito</h3>
       </div>
       <div class="mensajeError" v-else-if="confirmacion=='KO'">
          <p>cancel</p>
          <h3>{{mensajeError}}</h3>
       </div>
        <h1>{{$locales.ajustes.condicionesAlertas.title}}</h1>
        <div class="form-group">
          <form class="window-form" @submit.prevent="aceptar">
            <div class="row">
              <p>Para poder acceder a la gestión de alertas debes aceptar previamente la Cláusula de Protección de Datos LOPD</p>
            </div>
            <br/>
            <div class="row">
              <div @click="downloadPdf" class="downloadPdf">
                <!--<img id="adPayMarkImg" src="../assets/img/pdf-icon.png" alt="Descarga pdf"> -->
                <a id="pdfParticularConditions">S</a>
                <a id="textParticularConditions">Cláusula de Protección de Datos LOPD</a>
              </div>
            </div>
            <br/>
            <div class="margenCheckSwitch">
              <md-checkbox :disabled="isDisabledCheck" @change="onCheck" v-model="condiciones">Acepto las condiciones del servicio</md-checkbox>
            </div>
            
            <!-- Boton aceptar -->
            <input class="btnPrimary" type="submit" value="Aceptar" :disabled="isDisabled" v-if=beforeSubmit>
          </form>
        </div>
        <div v-if=datosFirma>
             <SignatureComponent :params="params" :datosFirma="datosFirma" :llamada="llamada" @aceptar="callBackAceptar" @cancelar="callBackCancelar"></SignatureComponent>
      </div> 
      </div>
    </section>
</template>

<script>
import InvoicesAlerts from '../models/InvoicesAlerts';
import SignatureComponent from './SignatureComponent';
import download from 'downloadjs';
export default {
    name : 'ConditionsAlertsComponent',
    data(){
      return{
        active: true,
        active2: false,
        active3: false,
        submitted: false,
        beforeSubmit: true,
        mensajeError: null,
        datosFirma: null,
        confirmacion: null,
        llamada: null,
        params: null,
        canales:[],
        resultado:null,
        isDisabledCheck:true,
        isDisabled:true,
        flagCondiciones:false,
        condiciones:false,
        model : new InvoicesAlerts()
      }
    },

     components: {
      SignatureComponent
    },
  
    mounted(){
    },
    
    methods: {
      refresh(){ //esto tiene la funcion de refrescar el componente cuando volvemos a clickar sobre el en las NavigationBars
        this.$parent.keyRefresh+=1; //al cambiar la key de esta section que lo abarca todo, vue dispara un update
      },
      callBackAceptar(confirmacion, mensaje){
      this.beforeSubmit = false;
      this.confirmacion = confirmacion;
      this.mensajeError = mensaje;
      this.datosFirma = null;
      },
     callBackCancelar(){
         this.beforeSubmit = true;
         this.datosFirma = null;
      },
      toggle () {
        this.active = true;
        this.active2 = false;
        this.active3 = false;
      },
      toggle2 () {
        this.active = false;
        this.active2 = true;
        this.active3 = false;
      },
      toggle3 () {
        this.active = false;
        this.active2 = false;
        this.active3 = true;
      },     

      downloadPdf() {
        const ventana=this;
        var idgdoc='ef3ef710-60e7-4540-9ba0-e541ce4721ad'; //el de eurocaja PRO por defecto por si la parametrizacion no funciona
        switch(location.origin){
          case 'http://localhost:8080':{ //local
            idgdoc='91a434e0-8164-4e6c-9973-0a38edaf2990';
            break;
          }
          case 'https://10.31.18.15':{ //desa prod
            idgdoc='91a434e0-8164-4e6c-9973-0a38edaf2990';
            break;
          }
          case 'https://10.31.132.5':{ //ec pre
            idgdoc='4978d489-ee79-44cc-91c1-5cbceed040f6';
            break;
          }
          case 'https://onesaitportal.eurocajarural.es':{ //ec pro
            idgdoc='cc0fe207-a98a-448a-89fb-26c23dfc861b';
            break;
          }
        }
        const baseURI = '/api-documents/documents/'+idgdoc;
        this.llamada = {
          urlEndpoint : baseURI,
          metodo : 'GET'
        };     
        let loader = this.$loading.show();
        this.$http.get(baseURI, {responseType: 'blob'})
        .then((result) => {
          const content = result.headers['content-type'];
          if(download(result.data, "ClausulaProteccionDatosLOPD", content)){ //si la descarga va bien
            var blob = new Blob([result.data], { type: 'application/pdf' });
            var url = window.URL.createObjectURL(blob);
            window.open(url); //abrimos el pdf
            this.flagCondiciones=true;
            if(this.flagCondiciones == true) {
              this.isDisabledCheck=false; //una vez descargado y abierto el pdf, habilitamos el check de que ha leido de las condiciones
            }
          }
        })
        .catch(error => {
          var codError = null;
          var descError = null;
          if(error.response){ 
            if(error.response.status != 200) {
                if(error.response.data.result) {
                  codError = error.response.data.result.errors[0].errorCode;
                  descError = error.response.data.result.errors[0].errorDescription;
                } else if(error.response.data.error) {
                  codError = error.response.data.error;
                  descError = error.response.data.error_description;
                } else {
                  codError = "400";
                  descError = "No se ha podido descargar el pdf";
                }
                ventana.mensajeError = codError + " - " + descError;
                ventana.confirmacion = "KO";
                window.scroll({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                });
            }
          }else{ //si no, por defecto
            ventana.mensajeError='No se ha podido descargar el pdf';
            ventana.confirmacion='KO';
          }
        })
        .then(function () {
          loader.hide();
        });
      },

      onCheck(e) {
        if(e) {
          this.isDisabled = false;
        } else {
          this.isDisabled = true;
        }
      },
      
      aceptar() {////SE ENVIAN LOS DATOS AL SERVICIO
        this.submitted = true;
        const ventana=this;
        const baseURI = '/api-notifications/notifications/userConditions';
        this.llamada = {
          urlEndpoint : baseURI,
          metodo : 'POST'
        };
        
        let loader = this.$loading.show();
        this.$http.post(baseURI, this.params)
        .then(() => {
          ventana.confirmacion='OK';
          this.$router.push({ name:'alertasMisFacturas'}).catch(()=>{});
        })
        .catch(error => {
          var codError = null;
          var descError = null;
            if(error.response){ 
              if(error.response.status == 400) {
                if(error.response.data.result.errors[0].errorCode == "096H") {
                  this.datosFirma = error.response.data.result.errors[0].info;
                  this.beforeSubmit = false;
                } else if(error.response.data.result.errors[0]) {
                  descError=error.response.data.result.errors[0].errorDescription;
                  codError=error.response.data.result.errors[0].errorCode;
                  ventana.mensajeError = codError + " - " + descError;
                  ventana.confirmacion='KO';
                }
              }
            }else{ //si no, por defecto
              ventana.beforeSubmit=true;
              ventana.mensajeError='Algo ha ido mal, no se ha podido completar la operación';
              ventana.confirmacion='KO';
            }
          })
        .then(function () {
          loader.hide();
        });
      },
    }
}
</script>